import { useTheme } from "@mui/material";
import { Canvas, useFrame } from "@react-three/fiber";
import { useEffect, useRef, useState } from "react";
import { Mesh } from "three";
import { GridShaderMaterial } from "./GridShaderMaterial";

const CustomShaderTorus = () => {
  const torusRef = useRef<Mesh>(null);
  const theme = useTheme();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useFrame((_state, delta) => {
    if (torusRef.current) {
      torusRef.current.rotation.z += delta * (isMobile ? 0.025 : 0.0075);
    }
  });

  return (
    <>
      <ambientLight intensity={1} color={theme.palette.yellow.main} />
      <directionalLight
        position={[0, 0, -4]}
        intensity={0.5}
        color={theme.palette.yellow.main}
      />

      <mesh
        ref={torusRef}
        rotation={[-Math.PI / 2.75, 0, 0]}
        position={[0, 4.3, -13]}
      >
        <torusGeometry args={[6.85, 0.8, 210, 210]} />
        <GridShaderMaterial
          baseWidth={0.05}
          maxWidth={0.045}
          gridSize={180}
          opacity={0.3}
          grid={9.1}
        />
      </mesh>
    </>
  );
};

const GridTorus = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Canvas
        style={{
          height: isMobile ? "40vh" : "100%",
          pointerEvents: "none",
          position: "absolute",
          width: "100%",
          zIndex: 200,
          left: 0,
          top: 0,
        }}
        camera={{
          position: [0, isMobile ? -0.25 : 0, 4],
          fov: 30,
        }}
        gl={{
          powerPreference: "high-performance",
          antialias: true,
          alpha: true,
        }}
        dpr={window.devicePixelRatio} // Use device pixel ratio for sharpness
        className="hero-torus"
        // linear // Enable linear color space for better quality
      >
        <CustomShaderTorus />
      </Canvas>
    </>
  );
};

export default GridTorus;
